export enum NoteSubjectType {
    FileRecord = 1,
    CloudFile = 2,
    OnPremAsset = 3,
    CloudAsset = 4
}
